import { useState, useContext } from 'react'
import AuthContext from 'contexte/AuthContext';
import { launchError } from 'components/notifications'
import BBookStatusCard from './components/BBookStatusCard';
import BBookTickers from './components/BBookTickers';
import BBookSpreads from './components/BBookSpreads';
import BBookUserSet from './components/BBookUserSet';
import BBookAlertBanners from './components/BBookAlertBanners';
import { usePolling, useT } from './hooks';
import { recall, remember } from './cache';
import {
  fetchBBookStatus,
  fetchMandatoryABookUsers,
  addMandatoryABookUser,
  removeMandatoryABookUser,
  fetchSpreadExemptUsers,
  addSpreadExemptUser,
  removeSpreadExemptUser,
} from 'services/bBookServices';

const STATUS_REFRESH_MS = 15000

const BBook = () => {

  const { t } = useT()
  const { user } = useContext(AuthContext)

  const [loading, setLoading] = useState(() => recall('status') === undefined)
  const [status, setStatus] = useState(() => recall('status') ?? { enabled: false, force_a_book: false, over_max_loss: false, engine_alive: false, engine_listening: false })
  const [tickersVersion, setTickersVersion] = useState(0) // bumps the spreads table when the instrument list changes


  // first load takes everything; later refreshes keep `enabled`, which a pending toggle may be changing
  usePolling(async () => {
    try {
      const data = remember('status', await fetchBBookStatus(user))
      if (loading) setStatus(data)
      else { const { enabled, ...engineOwned } = data; setStatus(prev => ({ ...prev, ...engineOwned })) }
    } catch (e) {
      if (loading) launchError(t('notifications.b_book.settings.error'))
    } finally {
      setLoading(false)
    }
  }, STATUS_REFRESH_MS, [user])


  return (
    <>
          <div>
            <div className='b_book_title_component'>
              <h1 className='b_book_page_title'>{t('pages.b_book.title')}</h1>
            </div>
            <BBookAlertBanners alerts={status.alerts} />

            {loading ? <div className='b_book_skeleton' aria-hidden='true' /> : <BBookStatusCard status={status} setStatus={setStatus} />}

            <BBookSpreads refreshKey={tickersVersion} />

            <BBookUserSet i18n='mandatory_a_book_users' fetchUsers={fetchMandatoryABookUsers} addUser={addMandatoryABookUser} removeUser={removeMandatoryABookUser} />

            <BBookUserSet i18n='spread_exempt_users' fetchUsers={fetchSpreadExemptUsers} addUser={addSpreadExemptUser} removeUser={removeSpreadExemptUser} />

            {/* long list, rarely edited: last on the page */}
            <BBookTickers onChange={() => setTickersVersion(v => v + 1)} />

          </div>
    </>
  )
}

export default BBook
